/**
 * @param {UserWebApi.SubscriptionType} type
 * @returns {boolean}
 */
function isPremiumPlus(type) {
    return type.toUpperCase() === 'HIFI' || type.toUpperCase() === 'PREMIUM_PLUS';
}

/**
 * @param {UserWebApi.SubscriptionType} subscriptionType1
 * @param {UserWebApi.SubscriptionType} subscriptionType2
 * @returns {boolean}
 */
function isSameSubscriptionType(subscriptionType1, subscriptionType2) {
    if (subscriptionType1.toUpperCase() === subscriptionType2.toUpperCase()) {
        return true;
    }

    if (isPremiumPlus(subscriptionType1) && isPremiumPlus(subscriptionType2)) {
        return true;
    }

    return false;
}

/**
 * @param {UserWebApi.SubscriptionType | string} type
 * @param {boolean} enableThirdTier
 * @returns {string}
 */
function getTranslationForSubscriptionType(type, enableThirdTier) {
    /** @type {Record<string, string>} */
    const translations = {
        PREMIUM: 'premium_old',
        PREMIUM_PLUS: 'hifi',
    };
    /** @type {Record<string, string>} */
    const thirdTierTranslations = {
        HIFI: 'premium_plus',
    };

    return (enableThirdTier ? thirdTierTranslations[type] : translations[type]) || type.toLowerCase();
}

/**
 * @param {UserWebApi.SubscriptionPlan | string} plan
 * @param {boolean} enableThirdTier
 * @returns {string}
 */
function getTranslationForSubscriptionPlan(plan, enableThirdTier) {
    /** @type {Record<string, string>} */
    const translations = {
        STANDARD: 'standard_old',
    };

    return enableThirdTier ? plan.toLowerCase() : (translations[plan] || plan.toLowerCase());
}

/**
 * @param {import("express").Request} req
 * @param {string | undefined} subscriptionType
 * @param {string | undefined} subscriptionPlan
 * @param {boolean} enableThirdTier
 * @returns {string | undefined}
 */
function getSubscriptionFullName(req, subscriptionType, subscriptionPlan, enableThirdTier) {
    const subscriptionTypeName = subscriptionType ? getTranslationForSubscriptionType(subscriptionType, enableThirdTier) : null;
    const subscriptionPlanName = subscriptionPlan ? getTranslationForSubscriptionPlan(subscriptionPlan, enableThirdTier) : null;
    if (!subscriptionTypeName || !subscriptionPlanName) {
        return undefined;
    }
    return `${req.translate(`offers.types.${subscriptionTypeName}.name`)} ${req.translate(`offers.plans.${subscriptionPlanName}.name`)}`;
}

export {
    getSubscriptionFullName,
    isPremiumPlus,
    isSameSubscriptionType,
    getTranslationForSubscriptionType,
    getTranslationForSubscriptionPlan,
};
